import { Avatar, Box, Button, List, ListItem, ListItemAvatar, ListItemText, Paper, Skeleton, Stack, Typography, useTheme, alpha, CircularProgress } from "@mui/material"

import CustomTypography from "../../../core/components/ui/CustomTypography"
import CustomChipComponent from "../../../core/components/common/custom-chip.component"
import CustomButton from "../../../core/components/ui/CustomButton";

import { useEffect, useState } from "react";
import useUserProfile from "../hooks/useUserProfile";
import { size } from "lodash";
import { EIDDetailsPage } from "../../eIDPlugin";

const ProfilePage = () => {

    const theme = useTheme();

    const {viewProfile, profileDetailsV2, loading} = useUserProfile();

    const [profileDetails, setProfileDetails] = useState(null)

    useEffect(() => {
        viewProfile()
    }, [])

    useEffect(() => {
        if (profileDetailsV2) {
            setProfileDetails(profileDetailsV2)
        }
    }, [JSON.stringify(profileDetailsV2)])

    return(
        <>
            <Box sx={{textAlign: "start", mt: 2}}>
                <CustomTypography 
                    variant="h3"
                    text={"Profile Details"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"View and manage your Electronic ID"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>
            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, mt: 3}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Stack
                    direction="row"
                    spacing={2}
                    flex={1}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                    >
                        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                            <ListItem>
                                <ListItemAvatar>
                                    <Avatar sx={{width: 80, height: 80}} />
                                </ListItemAvatar>
                                <ListItemText sx={{pl: 2}} primary={<Typography variant="h5">{profileDetails?.role}</Typography>} secondary={<Typography variant="subtitle2">{profileDetails?.profile_type}</Typography>} />
                            </ListItem>
                        </List>
                    </Stack>

                    <Stack
                    direction="column"
                    spacing={2}
                    flex={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "end",
                        pr: 4
                    }}
                    >
                        <CustomChipComponent category="profileStatusStyles"
                            label={(profileDetails?.status === "Active") ? "Active" 
                                : 
                                    (profileDetails?.status === "Deactivated") ? "Deactivated"
                                :
                                    (profileDetails?.status === "Pending") ? "Pending"
                                :
                                    profileDetails?.status
                            }
                        />
                    </Stack>
                </Stack>
            </Paper>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, p: 3, mt: 3}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="h3"
                            text={"Electronic ID"}
                            customStyles={{
                                marginBottom: 0, 
                                fontSize: 20,
                                fontWeight: 700
                            }}
                        />
                        <CustomTypography 
                            variant="caption"
                            text={"Manage your Electronic ID"}
                            customStyles={{
                                marginBottom: 0,
                                fontSize: 14 
                            }}
                        />
                    </Box>
                    
                </Stack>

                {loading ?
                    <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                :
                    profileDetailsV2 &&
                    <EIDDetailsPage profile_id={profileDetailsV2.profile_uid} />
                }

            </Paper>
            
            
        </>
    )
}

export default ProfilePage